import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LocalDataSource } from 'angular2-smart-table';
import { ICategory, IPricelist, PricelistService } from '../../../services/database/event/pricelist.service';
import { ImageService } from '../../../services/media/image.service';
import { ToastrService } from '../../../services/toastr/toastr.service';

@Component({
  selector: 'ngx-pricelist',
  templateUrl: './pricelist.component.html',
  styleUrls: ['./pricelist.component.scss']
})
export class PricelistComponent implements OnInit {

  pricelist: IPricelist[];
  categorySource: LocalDataSource = new LocalDataSource();
  source: LocalDataSource = new LocalDataSource();
  eventId: string;
  showCategoryDetail = false;
  showDetail = false;
  eventCategoryForm: FormGroup;
  eventPricelistForm: FormGroup;
  imgFile: string;
  imageChanged = false;
  photoURL: string;
  selectedPricelistItem: string;
  selectedCategory: string;
  category_data = [];
  category_id: string;

  categorySettings = {
    mode: 'external',
    hideHeader: false,
    actions: {
      add: true,
      edit: true,
      delete: true,
      position: 'right'
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
    },
    add: {
      addButtonContent: '<i class="nb-plus-circled"></i>',
    },
    columns: {
      name: {
        title: 'Name',
        type: 'string'
      },
      key: {
        title: 'ID',
        show: 'false'
      },
      sortOrder: {
        title: 'Sort order',
        type: 'number'
      }
    }
  }

  settings = {
    mode: 'external',
    hideHeader: false,
    actions: {
      add: true,
      edit: true,
      delete: true,
      position: 'right'
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
    },
    add: {
      addButtonContent: '<i class="nb-plus-circled"></i>',
    },
    columns: {
      photoURL: {
        title: 'Image',
        type: 'html',
        filter: false,
        valuePrepareFunction: (picture:string) => { return `<img width="50px" height="50px" src="${picture}" />`; },
      },
      category: {
        title: 'Category',
        type: 'string'
      },
      description: {
        title: 'Description',
        type: 'string',
      },
      price: {
        title: 'Price',
        type: 'number',
      },
      sortOrder: {
        title: 'Sort order',
        type: 'number'
      },
      key: {
        title: 'ID',
        show: 'false'
      }
    },
  };

  constructor(private pricelistService: PricelistService, private toastrService: ToastrService, private route: ActivatedRoute, private formBuilder: FormBuilder, private imageService: ImageService) { }

  ngOnInit(): void {
    this.eventId = this.route.snapshot.paramMap.get('eventId')
    this.pricelistService.getPricelist(this.eventId).subscribe((pricelist_items) => {
      const data = [];
      pricelist_items.forEach(pricelist => {
        data.push({
          description: pricelist.description,
          category: pricelist.category.name,
          price: pricelist.price,
          photoURL: pricelist.photoURL,
          key: pricelist.key,
          sortOrder: pricelist.sortOrder ? pricelist.sortOrder : 1
        })
      })
      this.source.load(data);
    })
    this.pricelistService.getCategory(this.eventId).subscribe((categories) => {
      this.category_data = [];
      categories.forEach((category) => {
        this.category_data.push({
          name: category.name,
          key: category.key,
          sortOrder: category.sortOrder ? category.sortOrder : 1
        })
      })
      this.categorySource.load(this.category_data);
    })
    this.initDetailForm();
    this.initCategoryForm();
  }

  initDetailForm() {
    this.photoURL = null;
    this.imgFile = null;
    this.eventPricelistForm = this.formBuilder.group({
      category_id: ['', Validators.required],
      description: ['', Validators.required],
      price: ['', Validators.required],
      sortOrder: [1, Validators.required],
      file: [''],
      logo: [''],
    });
  }

  initCategoryForm() {
    this.eventCategoryForm = this.formBuilder.group({
      name: ['', Validators.required],
      sortOrder: [1, Validators.required]
    });
  }

  onCreateCategory() {
    this.showCategoryDetail = true;
    this.initCategoryForm();
  }

  onEditCategory(event) : void {
    this.eventCategoryForm = this.formBuilder.group({
      name: [event.data.name, Validators.required],
      sortOrder: [event.data.sortOrder, Validators.required]
    });
    this.selectedCategory = event.data.key;
    this.showCategoryDetail = true;
  }

  onDeleteCategory(event): void {
    if (window.confirm('Are you sure you want to delete this bartender?')) {
      this.pricelistService.deleteCategory(this.eventId, event.data.key).then((succes) => {
          this.toastrService.show('Success', 'Successfully deleted category', 'success');
        })
        .catch((error) => {
          this.toastrService.show('Error', error, 'danger')
        })
    }
  }

  onCreate() {
    this.showDetail = true;
    this.initDetailForm();
  }

  onEdit(event) : void {
    this.category_id = event.data.category ? event.data.category.key : '';
    this.eventPricelistForm = this.formBuilder.group({
      category_id: [event.data.category ? event.data.category.key : '', Validators.required],
      description: [event.data.description, Validators.required],
      price: [event.data.price, Validators.required],
      file: [''],
      logo: [''],
      sortOrder: [event.data.sortOrder, Validators.required]
    });
    this.photoURL = event.data.photoURL;
    this.imgFile = null;
    this.showDetail = true;
    this.selectedPricelistItem = event.data.key;
  }

  onCancelCategory() {
    this.showCategoryDetail = false;
    this.selectedCategory = null;
  }

  onCancel() {
    this.showDetail = false;
    this.imageChanged = false;
    this.selectedPricelistItem = null;
    this.photoURL = null;
    this.imgFile = null;
  }

  onDelete(event): void {
    if (window.confirm('Are you sure you want to delete this bartender?')) {
      this.pricelistService.deletePricelist(this.eventId, event.data.key).then((succes) => {
          this.toastrService.show('Success', 'Successfully deleted product', 'success');
        })
        .catch((error) => {
          this.toastrService.show('Error', error, 'danger')
        })
    }
  }


  onImageChange(e) {
    const reader = new FileReader();
    this.imageChanged = true;
    let height;
    if(e.target.files && e.target.files.length) {
      const [file] = e.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.imgFile = reader.result as string;
        this.eventPricelistForm.patchValue({
          logo: reader.result
        });

      };
    }
  }

  get c() { return this.eventCategoryForm.controls; }

  get e() { return this.eventPricelistForm.controls; }

  updateAllStuff() {
    this.pricelistService.updateAllCategories();
  }

  onSubmitCategory() {
    if (this.eventCategoryForm.invalid) {
      this.toastrService.show('Form incomplete', 'Please provide all required fields', 'warning');
      return;
    };

    this.pricelistService.updateCategory(this.eventId, this.selectedCategory, {
      name: this.c.name.value,
      sortOrder: parseInt(this.c.sortOrder.value)
    })
    .then((success) => {
      this.toastrService.show(
        `Success`,
        `Category successfully updated..`,
        'success');
    }, (error) => {
      this.toastrService.show(
        'Error',
        `Error: ${error}`,
        'danger');
    }).finally(() => {
      this.selectedCategory = null;
      this.showCategoryDetail = false;
    });

  }

  getCategoryName(id: string) {
    let name = ''
    this.category_data.forEach((category:ICategory) => {
      if(category.key === id)
      {
        name = category.name;
      }
    })
    return name;
  }

  getCategorySortOrder(id: string) {
    let sortOrder = 1;
    this.category_data.forEach((category:ICategory) => {
      if(category.key === id)
      {
        sortOrder = category.sortOrder;
      }
    })
    return sortOrder;
  }

  onSubmit() {
    if (this.eventPricelistForm.invalid) {
      this.toastrService.show('Form incomplete', 'Please provide all required fields', 'warning');
      return;
    }

    const categoryObject = {
      key: this.e.category_id.value,
      name: this.getCategoryName(this.e.category_id.value),
      sortOrder: this.getCategorySortOrder(this.e.category_id.value)
    };
    if(this.imageChanged) {
      this.imageService.uploadPricelistPhoto(this.e.logo.value, this.eventId, this.selectedPricelistItem).then((uploadTask) => {
        uploadTask.ref.getDownloadURL().then((url) => {
          this.pricelistService.updatePricelistItem(this.eventId, this.selectedPricelistItem,{
            price: this.e.price.value,
            category: categoryObject,
            categoryId: categoryObject.key,
            description: this.e.description.value,
            photoURL: url,
            sortOrder: this.e.sortOrder.value
          })
          .then((success) => {
            this.toastrService.show(
              `Success`,
              `Product successfully updated..`,
              'success');
          }, (error) => {
            this.toastrService.show(
              'Error',
              `Error: ${error}`,
              'danger');
          }).finally(() => {
            this.selectedPricelistItem = null;
          });
        })
      }, (error) => {
        this.toastrService.show(
          'Error',
          `Error: ${error}`,
          'danger');
      }).finally(() => {
        this.showDetail = false;
        this.imageChanged = false;
      })
    }
    else {
      this.pricelistService.updatePricelistItem(this.eventId, this.selectedPricelistItem,{
        price: this.e.price.value,
        category: categoryObject,
        categoryId: categoryObject.key,
        description: this.e.description.value,
        photoURL: this.photoURL,
        sortOrder: this.e.sortOrder.value,
      })
      .then((success) => {
        this.toastrService.show(
          `Success`,
          `Product successfully updated..`,
          'success');
      }, (error) => {
        this.toastrService.show(
          'Error',
          `Error: ${error}`,
          'danger');
      }).finally(() => {
        this.showDetail = false;
        this.imageChanged = false;
        this.selectedPricelistItem = null;
      });
    }
  }

}
